/*
 *  Developed by CQ Inversiones SAS. Copyright (c) 2024. All rights reserved.
 *  Desarrollado por CQ Inversiones SAS. Copyright (c) 2024. Todos los derechos reservados.
 */

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez
 * Date:         6/05/24 - 13:20:07
 * Module name:  mkad-users.services
 * File name:    mkad-users.services.ts
 * IDE:          WebStorm
 */
import {Injectable} from '@angular/core';
import {MkadBaseService, URLS_SERVICE} from '@shared/services';
import {map, Observable} from 'rxjs';
import {HttpResponse, HttpStatusCode} from '@angular/common/http';
import {
  ValidateVirtualModelFormulaDto, ValidateVirtualCustomiseFormulaDto, CoreValidateFormulaInterface,
} from '@shared/interface/common/valid-formula.interface';

@Injectable({
  providedIn: 'root'
})
export class MkadCoreService extends MkadBaseService {
  private readonly validate = URLS_SERVICE.core.validateFormula;

  private validateFormula(param: ValidateVirtualModelFormulaDto | ValidateVirtualCustomiseFormulaDto | CoreValidateFormulaInterface): Observable<boolean> {
    return this.http.post<HttpResponse<boolean>>(this.baseCore + this.validate, param).pipe(
      map((prevResponse) => {
          if (!prevResponse) return true;
          return prevResponse.status === HttpStatusCode.Ok;
        },
      ));
  }

  validateSensorFormula(param: CoreValidateFormulaInterface): Observable<boolean> {
    return this.validateFormula(param);
  }

  validateModelFormula(param: ValidateVirtualModelFormulaDto | CoreValidateFormulaInterface): Observable<boolean> {
    return this.validateFormula(param);
  }

  validateCustomiseFormula(param: ValidateVirtualCustomiseFormulaDto | CoreValidateFormulaInterface): Observable<boolean> {
    return this.validateFormula(param);
  }

}
